import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { ResetPasswordConfirm } from '@/features/auth/components/ResetPasswordConfirm';
import { useAuthShellVariant } from '@/features/auth/hooks/useAuthShellVariant';

export const Route = createFileRoute('/reset-password/confirm')({
  component: Page,
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    role: search.role === 'staff' || search.role === 'client' ? search.role : undefined,
  }),
});

function Page() {
  const variant = useAuthShellVariant();
  const isStaff = variant === 'staff';
  return (
    <AuthLayout
      formSide={isStaff ? 'left' : 'right'}
      brandPanel={isStaff ? <StaffAuthBrandPanel /> : <ClientAuthBrandPanel />}
    >
      <ResetPasswordConfirm />
    </AuthLayout>
  );
}
